import axiosForGigbaseBiz from '../config'
import { DataResponse } from '../response'
import { CandidateDetail, CandidateSearchParameter } from 'types/job_candidate'
import { JobApplication } from 'types/job_applicationd'

const resource = 'job_applications'

export const requests = {
  fetchUnprocessedApplications: (
    parameter: CandidateSearchParameter,
    page: number,
    limit: number,
  ) => {
    return axiosForGigbaseBiz.get<DataResponse<JobApplication[]>>(resource, {
      params: {
        ...parameter,
        status: 1,
        page,
        limit,
      },
    })
  },
  fetchJobApplication: (jobApplicationId: string) => {
    return axiosForGigbaseBiz.get<DataResponse<CandidateDetail>>(
      `${resource}/${jobApplicationId}`,
    )
  },
  makeCandidate: async (jobApplicationId: number) => {
    return await axiosForGigbaseBiz.post<DataResponse<CandidateDetail>>(
      `${resource}/${jobApplicationId}/candidate`,
    )
  },
  close: async (jobApplicationId: number) => {
    return await axiosForGigbaseBiz.post<DataResponse<CandidateDetail>>(
      `${resource}/${jobApplicationId}/close`,
    )
  },
  assign: async (jobApplicationId: number) => {
    return await axiosForGigbaseBiz.post<DataResponse<void>>(
      `${resource}/${jobApplicationId}/assign`,
    )
  },
  refuse: async (jobApplicationId: number) => {
    return await axiosForGigbaseBiz.patch<DataResponse<void>>(
      `${resource}/${jobApplicationId}/refuse`,
    )
  },
}
